import Swiper from 'swiper/dist/js/swiper';
import Bowser from 'bowser/bundled';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import smoothscroll from 'smoothscroll-polyfill';
import { debounce } from 'lodash';
import isIEbrowser from '../helpers/is-IE';

export default class SingleProduct {
  static init(...parameters) {
    return new SingleProduct(...parameters);
  }


  constructor(container) {
    this.container = container;

    this.imageThumbnails = this.container.querySelectorAll('.thumbnail');
    this.thumbnailSwiperContainer = this.container.querySelector('.product-images .swiper-container');
    this.zoomedImageWrapper = this.container.querySelector('.zoomed-image');
    this.zoomSwiperContainer = this.zoomedImageWrapper.querySelector('.swiper-container');
    this.zoomedImageCloseButton = this.zoomedImageWrapper.querySelector('.close-button');
    this.zoomSwiperSlideButtons = this.zoomedImageWrapper.querySelectorAll('.swiper-button');

    //  Thumbnail scrollwrapper
    this.thumbnailListWrapper = this.container.querySelector('.thumbnail-wrapper');
    this.thumbnailsUl = this.container.querySelector('.thumbnails');
    this.thumbnailLeftButton = container.querySelector('.thumbnail-scroll-button.-left');
    this.thumbnailRightButton = container.querySelector('.thumbnail-scroll-button.-right');
    this.opacity = container.querySelector('.opacity-layer');

    this.tabMenuButtons = this.container.querySelectorAll('.tab-menu-button');
    this.selectedTabIcon = this.container.querySelector('.chosen-tab-icon');
    this.tabsWrapper = this.container.querySelector('.tabs-wrapper');
    this.tabs = this.tabsWrapper.querySelectorAll('.tab');

    this.materialListWrappers = this.container.querySelectorAll('.materials .scroll-wrapper');

    this.materials = this.container.querySelectorAll('.materials .material');

    this.materialInfoWrapper = this.container.querySelector('.material-info-wrapper');
    if (this.materialInfoWrapper) {
      this.materialInfo = this.materialInfoWrapper.querySelector('.material-info');
    }

    if (this.materialInfo) {
      this.materialInfoName = this.materialInfo.querySelector('.material-name');
      this.materialInfoImage = this.materialInfo.querySelector('.material-image');
      this.materialInfoCode = this.materialInfo.querySelector('.material-code');
      this.materialInfoColorCode = this.materialInfo.querySelector('.material-color-code');
      this.materialInfoPriceGroup = this.materialInfo.querySelector('.material-price-group');
      this.materialInfoColorRal = this.materialInfo.querySelector('.material-color-ral');
      this.materialInfoColorNcs = this.materialInfo.querySelector('.material-color-ncs');
      this.materialInfoSupplierColorCode = this.materialInfo.querySelector('.material-supplier-color-code');
      this.materialInfoComposition = this.materialInfo.querySelector('.material-composition');
      this.materialInfoDescription = this.materialInfo.querySelector('.material-description');
      this.materialInfoCloseButton = this.materialInfo.querySelector('.close-button');
    }

    const images = this.container.querySelectorAll('.product-image-thumbnail');
    [...images].forEach((thumbnails) => {
      thumbnails.addEventListener('load', () => {
        //  eslint-disable-next-line
        this.toggleThumbnailScroll(this.thumbnailListWrapper, this.thumbnailLeftButton, this.thumbnailRightButton, this.thumbnailsUl, this.opacity);
      });
    });

    const userAgent = Bowser.getParser(window.navigator.userAgent);
    const browser = userAgent.parsedResult.browser.name;
    const os = userAgent.parsedResult.os.name;
    this.isIosSafari = os === 'iOS' && browser === 'Safari';

    //  Adds class if the browser is IE
    const IE = isIEbrowser();
    // this.thumbnailList = this.container.querySelector('.thumbnails');
    this.badges = this.container.querySelector('.badges-wrapper');

    if (IE) {
      if (this.thumbnailList) {
        this.thumbnailList.classList.add('-IE');
      }
      if (this.badges) {
        this.badges.classList.add('-IE');
      }
    }

    smoothscroll.polyfill();

    this.setUpThumbnailSwiper();
    this.setUpZoomSwiper();

    this.thumbnailSwiperContainer.addEventListener('click', () => {
      this.openZoomImage();
    });

    this.zoomedImageCloseButton.addEventListener('click', () => {
      this.closeZoomImage();
    });

    [...this.tabMenuButtons].forEach((tabMenuButton) => {
      tabMenuButton.addEventListener('click', (event) => {
        this.selectTab(event);
      });
    });

    [...this.imageThumbnails].forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', (event) => {
        this.selectImage(event, index);
      });
    });

    this.thumbnailLeftButton.addEventListener('click', () => {
      this.thumbnailsUl.scrollBy({
        top: 0,
        left: -90,
        behavior: 'smooth',
      });
    });

    this.thumbnailRightButton.addEventListener('click', () => {
      this.thumbnailsUl.scrollBy({
        top: 0,
        left: 90,
        behavior: 'smooth',
      });
    });

    this.thumbnailsUl.addEventListener('scroll', debounce(() => { this.toggleThumbnailButtonVisibility(this.thumbnailLeftButton, this.thumbnailRightButton, this.thumbnailsUl, this.opacity); }, 50));

    [...this.materialListWrappers].forEach((scrollWrapper) => {
      const materialList = scrollWrapper.querySelector('ul');
      const scrollLeftButton = scrollWrapper.querySelector('.scroll-button.-left');
      const scrollRightButton = scrollWrapper.querySelector('.scroll-button.-right');

      scrollLeftButton.addEventListener('click', () => {
        materialList.scrollBy({
          top: 0,
          left: -105, // 105 = 1 material image
          behavior: 'smooth',
        });
      });

      scrollRightButton.addEventListener('click', () => {
        materialList.scrollBy({
          top: 0,
          left: 105, // 105 = 1 material image
          behavior: 'smooth',
        });
      });

      window.addEventListener('resize', debounce(() => {
        this.setUpThumbnailSwiper();
        this.updateSelectedTab();
        this.toggleThumbnailScroll(
          this.thumbnailListWrapper,
          this.thumbnailLeftButton,
          this.thumbnailRightButton,
          this.thumbnailsUl, this.opacity,
        );
        if (this.toggleScrollControls) {
          // eslint-disable-next-line
          this.toggleScrollControls(scrollWrapper, materialList, scrollLeftButton, scrollRightButton);
        }
      }, 50));

      materialList.addEventListener('scroll', debounce(() => { this.toggleButtonVisibility(scrollLeftButton, scrollRightButton, materialList); }, 50));
    });

    [...this.materials].forEach((material) => {
      material.addEventListener('click', (e) => {
        this.showMaterialInfo(e);
      });
    });

    if (this.materialInfoCloseButton) {
      this.materialInfoCloseButton.addEventListener('click', () => {
        this.hideMaterialInfo();
      });
    }
  }

  setUpThumbnailSwiper() {
    // NOTE: It's not possible to change effect for an initilized instance of Swiper
    // thus we need to destroy the old instance and initilize a new one with new settings
    // const swiperContainer = this.container.querySelector('.product-images .swiper-container');
    const swiperPagination = this.container.querySelector('.product-images .swiper-pagination');
    const isMobile = window.innerWidth < 768;

    const mobileSettings = {
      loop: true,
      pagination: {
        el: swiperPagination,
        type: 'bullets',
      },
    };

    const desktopSettings = {
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    };

    if (!this.thumbnailSwiper) {
      this.thumbnailSwiper = new Swiper(
        this.thumbnailSwiperContainer,
        isMobile ? mobileSettings : desktopSettings,
      );
    } else {
      const { effect } = this.thumbnailSwiper.originalParams;

      if (isMobile && effect !== 'slide') {
        this.thumbnailSwiper.destroy(true, true);
        this.thumbnailSwiper = new Swiper(this.thumbnailSwiperContainer, mobileSettings);
      }

      if (!isMobile && effect !== 'fade') {
        this.thumbnailSwiper.destroy(true, true);
        this.thumbnailSwiper = new Swiper(this.thumbnailSwiperContainer, desktopSettings);
      }
    }
  }

  setUpZoomSwiper() {
    const zoomSwiperNextSlideButton = this.zoomedImageWrapper.querySelector('.swiper-button.-next');
    const zoomSwiperPrevSlideButton = this.zoomedImageWrapper.querySelector('.swiper-button.-prev');

    this.zoomSwiper = new Swiper(this.zoomSwiperContainer, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      initialSlide: 0,
      loop: true,
      navigation: {
        nextEl: zoomSwiperNextSlideButton,
        prevEl: zoomSwiperPrevSlideButton,
      },
      observer: true,
      observeParents: true,
    });
  }

  openZoomImage() {
    this.zoomedImageWrapper.classList.add('-show');
    this.zoomedImageWrapper.classList.add('-animate-in');
    this.zoomSwiperContainer.classList.add('-animate-in');

    setTimeout(() => {
      [...this.zoomSwiperSlideButtons].forEach((button) => { button.classList.add('-animate-in'); });
    }, 200);

    this.zoomedImageWrapper.classList.remove('-animate-out');
    this.zoomSwiperContainer.classList.remove('-animate-out');

    const swiperHeight = getComputedStyle(document.documentElement).getPropertyValue('--inner-height');
    this.swiperSlides = this.zoomedImageWrapper.querySelectorAll('.swiper-slide');

    if (this.isIosSafari) {
      [...this.swiperSlides].forEach((slide) => {
        const slideImage = slide.firstElementChild;
        const slideImageStyle = slideImage.style;
        slideImageStyle.maxHeight = swiperHeight;
      });
    }

    disableBodyScroll([...this.swiperSlides][0]);

    if (this.zoomSwiper && this.thumbnailSwiper) {
      if (this.thumbnailSwiper.params.loop) {
        this.zoomSwiper.slideToLoop(this.thumbnailSwiper.activeIndex - 1, 0);
      } else {
        this.zoomSwiper.slideToLoop(this.thumbnailSwiper.activeIndex, 0);
      }
    }
  }

  closeZoomImage() {
    this.zoomedImageWrapper.classList.add('-animate-out');
    this.zoomSwiperContainer.classList.add('-animate-out');

    this.zoomedImageWrapper.classList.remove('-animate-in');
    this.zoomSwiperContainer.classList.remove('-animate-in');

    setTimeout(() => {
      this.zoomedImageWrapper.classList.remove('-show');
      [...this.zoomSwiperSlideButtons].forEach((button) => { button.classList.remove('-animate-in'); });
    }, 200);

    enableBodyScroll([...this.swiperSlides][0]);

    if (this.thumbnailSwiper && this.zoomSwiper) {
      if (this.thumbnailSwiper.params.loop) {
        this.thumbnailSwiper.slideToLoop(this.zoomSwiper.activeIndex - 1, 0);
      } else {
        this.thumbnailSwiper.slideTo(this.zoomSwiper.activeIndex - 1, 0);
      }
    }

    [...this.imageThumbnails].forEach((thumbnail, index) => {
      if (index === this.zoomSwiper.activeIndex - 1) {
        thumbnail.classList.add('-active');
      } else {
        thumbnail.classList.remove('-active');
      }
    });
  }

  selectImage(event, index) {
    const clickedThumbnail = event.currentTarget;

    if (this.thumbnailSwiper.params.loop) {
      this.thumbnailSwiper.slideToLoop(index);
    } else {
      this.thumbnailSwiper.slideTo(index);
    }

    [...this.imageThumbnails].forEach((thumbnail) => {
      if (thumbnail !== clickedThumbnail && thumbnail.classList.contains('-active')) {
        thumbnail.classList.remove('-active');
      } else {
        clickedThumbnail.classList.add('-active');
      }
    });
  }

  updateSelectedTab() {
    const clickedButton = this.container.querySelector('.tab-menu-button.-active');
    if (clickedButton) {
      const containerPosition = this.container.getBoundingClientRect();
      const clickedButtonPosition = clickedButton.getBoundingClientRect();
      if (containerPosition.width > 1625) {
        const leftMargin = (window.innerWidth - 1400) / 2;
        this.selectedTabIcon.style.left = `${clickedButtonPosition.left - leftMargin + (clickedButtonPosition.width / 2) - 11}px`;
      } else if (containerPosition.width >= 977) {
        this.selectedTabIcon.style.left = `${clickedButtonPosition.left - 120 + (clickedButtonPosition.width / 2) - 11}px`;
      } else {
        this.selectedTabIcon.classList.remove('-visible');
      }
    }
  }

  selectTab(event) {
    const clickedButton = event.currentTarget;
    const selectedTab = this.tabsWrapper.querySelector(`.tab.-${clickedButton.dataset.tab}`);

    this.tabsWrapper.classList.add('-tab-showing');

    if (!this.selectedTabIcon.classList.contains('-visible')) {
      this.selectedTabIcon.classList.add('-visible');
    }
    const containerPosition = this.container.getBoundingClientRect();
    const clickedButtonPosition = clickedButton.getBoundingClientRect();
    if (containerPosition.width > 1625) {
      const leftMargin = (window.innerWidth - 1400) / 2;
      this.selectedTabIcon.style.left = `${clickedButtonPosition.left - leftMargin + (clickedButtonPosition.width / 2) - 11}px`;
    } else if (containerPosition.width >= 977) {
      this.selectedTabIcon.style.left = `${clickedButtonPosition.left - 120 + (clickedButtonPosition.width / 2) - 11}px`;
    } else {
      this.selectedTabIcon.classList.remove('-visible');
    }

    [...this.tabMenuButtons].forEach((button) => {
      if (button !== clickedButton && button.classList.contains('-active')) {
        button.classList.remove('-active');
      } else {
        clickedButton.classList.add('-active');
      }
    });

    [...this.tabs].forEach((tab) => {
      if (tab !== selectedTab && tab.classList.contains('-show')) {
        tab.classList.remove('-show');
      } else {
        selectedTab.classList.add('-show');
      }
    });

    [...this.materialListWrappers].forEach((scrollWrapper) => {
      const materialList = scrollWrapper.querySelector('ul');
      const scrollLeftButton = scrollWrapper.querySelector('.scroll-button.-left');
      const scrollRightButton = scrollWrapper.querySelector('.scroll-button.-right');

      this.toggleScrollControls(scrollWrapper, materialList, scrollLeftButton, scrollRightButton);
    });
  }

  toggleScrollControls(scrollWrapper, materialList, scrollLeftButton, scrollRightButton) {
    if (materialList && scrollWrapper) {
      if (materialList.scrollWidth > scrollWrapper.offsetWidth) {
        this.toggleButtonVisibility(scrollLeftButton, scrollRightButton, materialList);
      } else {
        scrollLeftButton.classList.add('-hide');
        scrollRightButton.classList.add('-hide');
      }
    }
  }


  toggleButtonVisibility(scrollLeftButton, scrollRightButton, materialList) {
    scrollRightButton.classList.remove('-hide');

    // Show left scroll button
    if (materialList.scrollLeft > 1 && scrollLeftButton.classList.contains('-hide')) {
      scrollLeftButton.classList.remove('-hide');
    }

    // Hide left scroll button
    if (materialList.scrollLeft < 1 && !scrollLeftButton.classList.contains('-hide')) {
      scrollLeftButton.classList.add('-hide');
    }

    // Show right scroll button
    if (materialList.scrollLeft > 1 && scrollLeftButton.classList.contains('-hide')) {
      scrollRightButton.classList.remove('-hide');
    }

    // Show right scroll button
    if (materialList.scrollLeft + materialList.offsetWidth
      <= materialList.scrollWidth && scrollLeftButton.classList.contains('-hide')) {
      scrollRightButton.classList.remove('-hide');
    }

    // Hide right scroll button
    if (materialList.scrollLeft + materialList.offsetWidth
      >= materialList.scrollWidth && !scrollLeftButton.classList.contains('-hide')) {
      scrollRightButton.classList.add('-hide');
    }
  }
  //  eslint-disable-next-line
  toggleThumbnailScroll(thumbnailListWrapper, thumbnailLeftButton, thumbnailRightButton, thumbnailList, opacity) {
    if (thumbnailList && thumbnailListWrapper) {
      if (thumbnailList.scrollWidth > thumbnailListWrapper.offsetWidth - 100) {
        //  eslint-disable-next-line
        this.toggleThumbnailButtonVisibility(thumbnailLeftButton, thumbnailRightButton, thumbnailList, opacity)
      } else {
        if (!thumbnailLeftButton.classList.contains('-hide')) {
          thumbnailLeftButton.classList.add('-hide');
        }
        if (!thumbnailRightButton.classList.contains('-hide')) {
          thumbnailRightButton.classList.add('-hide');
        }
      }
    }
  }


  // eslint-disable-next-line max-len
  toggleThumbnailButtonVisibility(thumbnailLeftButton, thumbnailRightButton, thumbnailList, opacity) {
    thumbnailRightButton.classList.remove('-hide');

    // Show left scroll button
    if (thumbnailList.scrollLeft > 1 && thumbnailLeftButton.classList.contains('-hide')) {
      thumbnailLeftButton.classList.remove('-hide');
    }

    // Hide left scroll button
    if (thumbnailList.scrollLeft < 1 && !thumbnailLeftButton.classList.contains('-hide')) {
      thumbnailLeftButton.classList.add('-hide');
    }

    // Show right scroll button
    if (thumbnailList.scrollLeft > 1 && thumbnailLeftButton.classList.contains('-hide')) {
      thumbnailRightButton.classList.remove('-hide');
      opacity.classList.add('opacity-layer');
    }

    // Show right scroll button
    if (thumbnailList.scrollLeft + thumbnailList.offsetWidth
      <= thumbnailList.scrollWidth && thumbnailLeftButton.classList.contains('-hide')) {
      thumbnailRightButton.classList.remove('-hide');
      opacity.classList.add('opacity-layer');
    }

    // Hide right scroll button
    if (thumbnailList.scrollLeft + thumbnailList.offsetWidth
      >= thumbnailList.scrollWidth && !thumbnailLeftButton.classList.contains('-hide')) {
      thumbnailRightButton.classList.add('-hide');
      opacity.classList.remove('opacity-layer');
    }
  }


  showMaterialInfo(e) {
    const selectedMaterial = e.currentTarget;
    const dataSetObj = Object.assign({}, selectedMaterial.dataset);

    Object.entries(dataSetObj).forEach(([key, val]) => {
      const ddEl = this[`materialInfo${key.charAt(0).toUpperCase()}${key.slice(1)}`];
      const dtEl = (key === 'image' || key === 'description') ? null : ddEl.previousElementSibling;

      if (!val) {
        ddEl.classList.add('-hide');
        if (dtEl) {
          dtEl.classList.add('-hide');
        }
      }

      switch (key) {
        case 'image':
          ddEl.src = val;
          break;
        case 'description':
          ddEl.innerHTML = val;
          break;
        default:
          ddEl.textContent = val;
          break;
      }
    });

    this.materialInfoWrapper.classList.remove('-hide');
    this.materialInfoWrapper.classList.add('-animate-in');
    this.materialInfo.classList.add('-animate-in');

    this.materialInfoWrapper.classList.remove('-animate-out');
    this.materialInfo.classList.remove('-animate-out');

    if (this.isIosSafari) {
      const materialInfoHeight = getComputedStyle(document.documentElement)
        .getPropertyValue('--inner-height');

      if (window.innerWidth < '768') {
        // iPhone
        this.materialInfo.style.height = materialInfoHeight;
      } else {
        // iPad
        this.materialInfo.style.height = `calc(${materialInfoHeight} - 80px)`;
      }
    }

    disableBodyScroll(this.materialInfo);
  }

  hideMaterialInfo() {
    this.materialInfoWrapper.classList.remove('-animate-in');
    this.materialInfo.classList.remove('-animate');

    this.materialInfoWrapper.classList.add('-animate-out');
    this.materialInfo.classList.add('-animate-out');

    setTimeout(() => {
      this.materialInfoWrapper.classList.add('-hide');
    }, 200);

    enableBodyScroll(this.materialInfo);

    const dtElements = this.materialInfoWrapper.querySelectorAll('.material-data > dl > dt');
    const ddElements = this.materialInfoWrapper.querySelectorAll('.material-data > dl > dd');

    [...dtElements].forEach((dtElement) => {
      if (dtElement.classList.contains('-hide')) {
        dtElement.classList.remove('-hide');
      }
    });

    [...ddElements].forEach((ddElement) => {
      if (ddElement.classList.contains('-hide')) {
        ddElement.classList.remove('-hide');
      }
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-single-product', SingleProduct.init);
}
